import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
var _excluded = ["client_key"];
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import loader from '../../common/loader';
import Request from '../../common/network';
import cookie from '../../common/cookie';
import miloRequest from '../../common/network';
import ATM from '../../util/atm';
import { getGameId } from '../login/common';
import platform from '../../common/platform';
import useDefer from '../../util/defer';
import miloObject from '../../common/object'; // 微信JSSDK add by weiztang 微信接口开放改造

var jsApi = 'https://unpkg.byted-static.com/bridge/douyin_open/1.0.10/lib/douyin_open.umd.js'; // const qqAppid = '';
// const wxAppid = '';

var loginFuncsTips = 'Please use LoginManager,exec from jsBridge is not effect.';
var miloSelfConfig = {
  isMiloWayCookies: true,
  appName: 'douyin'
};
var defaultParams = {
  client_key: 'aw8w9e55mhhfbsgy'
}; // 加载wxjssdk，活动开发可以自行指定版本号

var loadJsApi = function loadJsApi(jsApiCustom) {
  return new Promise(function (resolve, reject) {
    var loadJsApiUrl = jsApiCustom || jsApi;
    console.log('loadJsApiURL', loadJsApiUrl); // 如果有wx全局变量且有wx.config初始化方法 weiztang

    if (window.douyin_open && window.douyin_open.config) {
      // console.log('window.DouyinOpenJSBridge', window.DouyinOpenJSBridge);
      resolve(window.douyin_open);
      return;
    }

    loader.loadScript(loadJsApiUrl).then(function (isLoad) {
      if (isLoad && window.DouyinOpenJSBridge) {
        // console.log('window.DouyinOpenJSBridge', window.DouyinOpenJSBridge);
        resolve(window.DouyinOpenJSBridge);
      } else {
        reject({
          errMsg: 'load douyin jsapi failed'
        });
      }
    })["catch"](function (e) {
      reject(e);
    });
  });
}; // 初始化配置，包括签名等


var initConfig = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
    var initParams, client_key, sign, signature, timestamp, nonce_str, dySdk, dyConfig;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            initParams = _objectSpread(_objectSpread({}, defaultParams), params);
            client_key = initParams.client_key;
            _context.next = 4;
            return getSignature(initParams);

          case 4:
            sign = _context.sent;

            if (sign) {
              _context.next = 7;
              break;
            }

            return _context.abrupt("return", {
              errMsg: 'get sign failed',
              initOK: false
            });

          case 7:
            signature = sign.signature, timestamp = sign.timestamp, nonce_str = sign.nonce_str;
            _context.prev = 8;
            _context.next = 11;
            return loadJsApi();

          case 11:
            dySdk = _context.sent;
            dyConfig = {
              client_key: client_key,
              signature: signature,
              timestamp: timestamp,
              nonce_str: nonce_str,
              url: location.href
            }; // 初始化

            dySdk.config({
              params: dyConfig
            });
            return _context.abrupt("return", {
              errMsg: '',
              initOK: true
            });

          case 17:
            _context.prev = 17;
            _context.t0 = _context["catch"](8);
            return _context.abrupt("return", {
              errMsg: _context.t0,
              initOK: false
            });

          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[8, 17]]);
  }));

  return function initConfig(_x) {
    return _ref.apply(this, arguments);
  };
}();
/**
 * @method getSignature
 * @param {Object} params
 * @param {String} sSignType 签名类型，默认dyJsSdkSign，可选：dyOpenSign
 * @description 获取签名的方法
 * @return {Promise}
*/


var getSignature = function getSignature(params) {
  var sSignType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'dyJsSdkSign';
  var defer = useDefer();

  var _defaultParams$params = _objectSpread(_objectSpread({}, defaultParams), params),
      _defaultParams$params2 = _defaultParams$params.client_key,
      client_key = _defaultParams$params2 === void 0 ? defaultParams.client_key : _defaultParams$params2,
      signParams = _objectWithoutProperties(_defaultParams$params, _excluded);

  var requestSignParams = _objectSpread({
    a: sSignType,
    // 分享的签名计算不需要url
    // url: encodeURIComponent(encodeURIComponent(location.href)),
    appid: client_key
  }, signParams);

  Request.ajax({
    url: 'https://ams.game.qq.com/ams/userLoginSvr',
    type: 'GET',
    data: requestSignParams,
    dataType: 'jsonp',
    success: function success(retObj) {
      console.log('[Milo get Douyin Signature]', retObj);

      if (0 == (retObj === null || retObj === void 0 ? void 0 : retObj.iRet)) {
        defer.resolve(_objectSpread(_objectSpread({}, retObj.data), {
          client_key: client_key
        }));
      } else {
        defer.resolve(null);
      }
    },
    error: function error() {
      defer.resolve(null);
    }
  });
  return defer;
}; // 调用抖音分享,直接分享


var share = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(params) {
    var _yield$getShareSchema, sSchemaLink, errMsg;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getShareSchema(params);

          case 2:
            _yield$getShareSchema = _context2.sent;
            sSchemaLink = _yield$getShareSchema.sSchemaLink;
            errMsg = _yield$getShareSchema.errMsg;

            if (!sSchemaLink) {
              _context2.next = 9;
              break;
            }

            console.log('sSchemaLink:', sSchemaLink);
            location.href = sSchemaLink;
            return _context2.abrupt("return", {
              isOK: true,
              errMsg: ''
            });

          case 9:
            return _context2.abrupt("return", {
              isOK: false,
              errMsg: errMsg
            });

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function share(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
/**
 * @method getShareSchema
 * @param {Object} params
 * @description 获取分享schema的方法
 * @return {Promise}
*/


var getShareSchema = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(params) {
    var shareParams, signParams, sign, _shareParams$state, state, _shareParams$image_pa, image_path, _shareParams$image_li, image_list_path, _shareParams$video_pa, video_path, _shareParams$hashtag_, hashtag_list, _shareParams$micro_ap, micro_app_info, _shareParams$share_to, share_to_publish, _shareParams$title, title, _shareParams$poi_id, poi_id, sShareParams;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            shareParams = params.shareParams, signParams = params.signParams;
            sign = _objectSpread({}, signParams);

            if (!(!signParams || !signParams.client_key || !signParams.signature || !signParams.timestamp || !signParams.nonce_str)) {
              _context3.next = 8;
              break;
            }

            _context3.next = 5;
            return getSignature(signParams, 'dyOpenSign');

          case 5:
            sign = _context3.sent;

            if (sign) {
              _context3.next = 8;
              break;
            }

            return _context3.abrupt("return", {
              errMsg: 'get sign failed',
              isOK: false
            });

          case 8:
            // 拿分享参数
            _shareParams$state = shareParams.state, state = _shareParams$state === void 0 ? 'milo_douyin_share' : _shareParams$state, _shareParams$image_pa = shareParams.image_path, image_path = _shareParams$image_pa === void 0 ? '' : _shareParams$image_pa, _shareParams$image_li = shareParams.image_list_path, image_list_path = _shareParams$image_li === void 0 ? [] : _shareParams$image_li, _shareParams$video_pa = shareParams.video_path, video_path = _shareParams$video_pa === void 0 ? '' : _shareParams$video_pa, _shareParams$hashtag_ = shareParams.hashtag_list, hashtag_list = _shareParams$hashtag_ === void 0 ? [] : _shareParams$hashtag_, _shareParams$micro_ap = shareParams.micro_app_info, micro_app_info = _shareParams$micro_ap === void 0 ? {} : _shareParams$micro_ap, _shareParams$share_to = shareParams.share_to_publish, share_to_publish = _shareParams$share_to === void 0 ? 0 : _shareParams$share_to, _shareParams$title = shareParams.title, title = _shareParams$title === void 0 ? document.title : _shareParams$title, _shareParams$poi_id = shareParams.poi_id, poi_id = _shareParams$poi_id === void 0 ? '' : _shareParams$poi_id;
            sShareParams = miloObject.serialize({
              share_type: 'h5',
              client_key: sign.client_key,
              nonce_str: sign.nonce_str,
              timestamp: sign.timestamp,
              signature: sign.signature,
              state: state,
              image_path: image_path,
              image_list_path: image_list_path,
              video_path: video_path,
              hashtag_list: hashtag_list,
              micro_app_info: micro_app_info,
              share_to_publish: Number(share_to_publish) || 0,
              // 为1时立即发布到都有发布页
              title: title,
              poi_id: poi_id
            });
            return _context3.abrupt("return", {
              isOK: true,
              sSchemaLink: "snssdk1128://openplatform/share?".concat(sShareParams)
            });

          case 11:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function getShareSchema(_x3) {
    return _ref3.apply(this, arguments);
  };
}();

var setAppCookie = function setAppCookie() {
  return new Promise(function (resolve) {
    console.log(loginFuncsTips);
    resolve();
  });
};

var getLoginType = function getLoginType() {
  return new Promise(function (resolve) {
    // 这里是是APP登录态是否特殊处理的开关之一
    resolve(null);
  });
};

var logout = function logout() {
  console.log(loginFuncsTips);
};

var douyin = {
  setAppCookie: setAppCookie,
  getLoginType: getLoginType,
  logout: logout,
  // jssdk相关方法
  loadJsApi: loadJsApi,
  getSignature: getSignature,
  initConfig: initConfig,
  getShareSchema: getShareSchema,
  share: share,
  miloSelfConfig: miloSelfConfig
};
export default douyin;